<template>
  <li
    role="treeitem"
    :id="model.id"
    :title="title"
    :class="classes"
    :draggable="draggable"
    :data-cy="getCameraDataCy()"
    @dragstart.stop="onItemDragStart($event, _self, _self.model)"
    @dragend.stop.prevent="onItemDragEnd($event, _self, _self.model)"
    @dragover.stop.prevent="isDragEnter = true"
    @dragenter.stop.prevent="isDragEnter = true"
    @dragleave.stop.prevent="isDragEnter = false"
    @drop.stop.prevent="handleItemDrop($event, _self, _self.model)"
    @mouseover="handleItemMouseOver"
    @mouseleave="handleItemMouseOut"
    v-if="isVisibile"
  >
    <div role="presentation" :class="wholeRowClasses" v-if="isWholeRow">&nbsp;</div>
    <i class="tree-icon tree-ocl" role="presentation" @click="handleItemToggle"></i>
    <div :class="anchorClasses" v-on="events" @click="handleItemToggle">
      <i
        class="tree-icon tree-checkbox"
        role="presentation"
        v-if="showCheckbox && !model.loading"
      ></i>
      <slot :vm="this" :model="model">
        <svg
          v-if="themeIconClasses[2].hasOwnProperty('custom custom-web')"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            d="M7.571,13.286a1.143,1.143,0,1,0-1.143-1.143A1.143,1.143,0,0,0,7.571,13.286Zm4.571-1.143A1.143,1.143,0,1,1,11,11,1.143,1.143,0,0,1,12.143,12.143Zm2.286,1.143a1.143,1.143,0,1,0-1.143-1.143A1.143,1.143,0,0,0,14.429,13.286ZM3,5.857A2.857,2.857,0,0,1,5.857,3H16.143A2.857,2.857,0,0,1,19,5.857V16.143A2.857,2.857,0,0,1,16.143,19H5.857A2.857,2.857,0,0,1,3,16.143ZM5.857,4.143A1.714,1.714,0,0,0,4.143,5.857V16.143a1.714,1.714,0,0,0,1.714,1.714H16.143a1.714,1.714,0,0,0,1.714-1.714V7.571H10.429A1.714,1.714,0,0,1,8.714,5.857V4.143Zm12,1.714a1.714,1.714,0,0,0-1.714-1.714H9.857V5.857a.571.571,0,0,0,.571.571h7.429Z"
            transform="translate(-3 -3)"
            fill="#fff"
          />
        </svg>
        <template v-else>
          <i :class="themeIconClasses" role="presentation" v-if="!model.loading"></i>
        </template>
        <span
          v-html="model[textFieldName]"
          :style="
            themeIconClasses[2].hasOwnProperty('custom custom-camera-online')
              ? 'background:#00FF00'
              : themeIconClasses[2].hasOwnProperty('custom custom-camera-offline')
              ? 'background:#f53214'
              : ''
          "
        ></span>
      </slot>
    </div>
    <ul
      role="group"
      ref="group"
      class="tree-children"
      v-if="isFolder"
      :style="groupStyle"
    >
      <tree-item
        v-for="(child, index) in model[childrenFieldName]"
        :key="index"
        :data="child"
        :text-field-name="textFieldName"
        :value-field-name="valueFieldName"
        :children-field-name="childrenFieldName"
        :item-events="itemEvents"
        :whole-row="wholeRow"
        :show-checkbox="showCheckbox"
        :allow-transition="allowTransition"
        :height="height"
        :parent-item="model[childrenFieldName]"
        :on-item-click="onItemClick"
        :on-item-toggle="onItemToggle"
        :on-item-drag-start="onItemDragStart"
        :on-item-drag-end="onItemDragEnd"
        :on-item-drop="onItemDrop"
        :on-item-open-in-new-tab="onItemOpenInNewTab"
        :on-item-paginate="onItemPaginate"
        :klass="index === model[childrenFieldName].length - 1 ? 'tree-last' : ''"
        :draggable="resolveDraggableStatus(child)"
        :data-parent="buildParentData(model)"
        :mode="mode"
        :role="role"
      >
        <template slot-scope="_">
          <slot :vm="_.vm" :model="_.model">
            <svg
              v-if="
                _.vm.themeIconClasses[2].hasOwnProperty('custom custom-camera-online')
              "
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 17.039 17.067"
              style="margin-right: 8px; margin-left: 5px"
            >
              <g transform="translate(-5 -6.53)">
                <path
                  class="icon"
                  d="M21.3,6.53H5.743A.745.745,0,0,0,5,7.273v2.812a.745.745,0,0,0,.743.743h.634v4.56a7.143,7.143,0,1,0,14.286,0V10.824H21.3a.745.745,0,0,0,.743-.743V7.273A.745.745,0,0,0,21.3,6.53Zm-1.315,8.857a6.461,6.461,0,0,1-12.923,0V10.824H19.978v4.563Zm1.377-5.306a.061.061,0,0,1-.061.061H5.743a.061.061,0,0,1-.061-.061V7.273a.061.061,0,0,1,.061-.061H21.3a.061.061,0,0,1,.061.061Z"
                  fill="#fff"
                />
                <path
                  class="icon"
                  d="M22.05,31.466a4.108,4.108,0,1,0-4.11-4.107A4.115,4.115,0,0,0,22.05,31.466Zm0-7.535a3.427,3.427,0,1,1-3.428,3.425A3.433,3.433,0,0,1,22.05,23.932Z"
                  transform="translate(-8.53 -11.022)"
                  fill="#fff"
                />
                <path
                  class="icon"
                  d="M26.79,33.749a1.66,1.66,0,1,0-1.66-1.66A1.662,1.662,0,0,0,26.79,33.749Zm0-2.634a.978.978,0,1,1-.978.978A.98.98,0,0,1,26.79,31.115Z"
                  transform="translate(-13.27 -15.755)"
                  fill="#fff"
                />
              </g>
              <g
                transform="translate(10.934 11.067)"
                fill="#00ff00"
                stroke="#fff"
                stroke-width="1"
              >
                <circle cx="3" cy="3" r="3" stroke="none" />
                <circle cx="3" cy="3" r="2.5" fill="none" />
              </g>
            </svg>
            <svg
              v-else-if="
                _.vm.themeIconClasses[2].hasOwnProperty('custom custom-camera-offline')
              "
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 17.039 17.067"
              style="margin-right: 8px; margin-left: 5px"
            >
              <g transform="translate(-5 -6.53)">
                <path
                  class="icon"
                  d="M21.3,6.53H5.743A.745.745,0,0,0,5,7.273v2.812a.745.745,0,0,0,.743.743h.634v4.56a7.143,7.143,0,1,0,14.286,0V10.824H21.3a.745.745,0,0,0,.743-.743V7.273A.745.745,0,0,0,21.3,6.53Zm-1.315,8.857a6.461,6.461,0,0,1-12.923,0V10.824H19.978v4.563Zm1.377-5.306a.061.061,0,0,1-.061.061H5.743a.061.061,0,0,1-.061-.061V7.273a.061.061,0,0,1,.061-.061H21.3a.061.061,0,0,1,.061.061Z"
                  fill="#fff"
                />
                <path
                  class="icon"
                  d="M22.05,31.466a4.108,4.108,0,1,0-4.11-4.107A4.115,4.115,0,0,0,22.05,31.466Zm0-7.535a3.427,3.427,0,1,1-3.428,3.425A3.433,3.433,0,0,1,22.05,23.932Z"
                  transform="translate(-8.53 -11.022)"
                  fill="#fff"
                />
                <path
                  class="icon"
                  d="M26.79,33.749a1.66,1.66,0,1,0-1.66-1.66A1.662,1.662,0,0,0,26.79,33.749Zm0-2.634a.978.978,0,1,1-.978.978A.98.98,0,0,1,26.79,31.115Z"
                  transform="translate(-13.27 -15.755)"
                  fill="#fff"
                />
              </g>
              <g
                transform="translate(10.934 11.067)"
                fill="#f53214"
                stroke="#fff"
                stroke-width="1"
              >
                <circle cx="3" cy="3" r="3" stroke="none" />
                <circle cx="3" cy="3" r="2.5" fill="none" />
              </g>
            </svg>
            <svg
              v-else-if="
                _.vm.themeIconClasses[2].hasOwnProperty('custom custom-camera-ptz-online')
              "
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 17.039 17.067"
              style="margin-right: 8px; margin-left: 5px"
            >
              <g transform="translate(-0.6 -0.6) scale(0.6603)">
                <path
                  class="icon"
                  d="M5.54 8.46L2 12l3.54 3.54l1.76-1.77L5.54 12l1.76-1.77zm6.46 10l-1.77-1.76l-1.77 1.76L12 22l3.54-3.54l-1.77-1.76zm6.46-10l-1.76 1.77L18.46 12l-1.76 1.77l1.76 1.77L22 12zm-10-2.92l1.77 1.76L12 5.54l1.77 1.76l1.77-1.76L12 2z"
                  fill="#fff"
                />
                <path
                  class="icon"
                  d="M9,12a3,3,0,1,0,6,0a3,3,0,1,0,-6,0Z"
                  fill="#fff"
                />
              </g>
              <g
                transform="translate(10.934 11.067)"
                fill="#00ff00"
                stroke="#fff"
                stroke-width="1"
              >
                <circle cx="3" cy="3" r="3" stroke="none" />
                <circle cx="3" cy="3" r="2.5" fill="none" />
              </g>
            </svg>
            <svg
              v-else-if="
                _.vm.themeIconClasses[2].hasOwnProperty('custom custom-camera-ptz-offline')
              "
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 17.039 17.067"
              style="margin-right: 8px; margin-left: 5px"
            >
              <g transform="translate(-0.6 -0.6) scale(0.6603)">
                <path
                  class="icon"
                  d="M5.54 8.46L2 12l3.54 3.54l1.76-1.77L5.54 12l1.76-1.77zm6.46 10l-1.77-1.76l-1.77 1.76L12 22l3.54-3.54l-1.77-1.76zm6.46-10l-1.76 1.77L18.46 12l-1.76 1.77l1.76 1.77L22 12zm-10-2.92l1.77 1.76L12 5.54l1.77 1.76l1.77-1.76L12 2z"
                  fill="#fff"
                />
                <path
                  class="icon"
                  d="M9,12a3,3,0,1,0,6,0a3,3,0,1,0,-6,0Z"
                  fill="#fff"
                />
              </g>
              <g
                transform="translate(10.934 11.067)"
                fill="#f53214"
                stroke="#fff"
                stroke-width="1"
              >
                <circle cx="3" cy="3" r="3" stroke="none" />
                <circle cx="3" cy="3" r="2.5" fill="none" />
              </g>
            </svg>
            <svg
              v-else-if="_.vm.themeIconClasses[2].hasOwnProperty('custom custom-web')"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              style="margin-right: 8px; margin-left: 5px"
            >
              <path
                class="icon"
                d="M7.571,13.286a1.143,1.143,0,1,0-1.143-1.143A1.143,1.143,0,0,0,7.571,13.286Zm4.571-1.143A1.143,1.143,0,1,1,11,11,1.143,1.143,0,0,1,12.143,12.143Zm2.286,1.143a1.143,1.143,0,1,0-1.143-1.143A1.143,1.143,0,0,0,14.429,13.286ZM3,5.857A2.857,2.857,0,0,1,5.857,3H16.143A2.857,2.857,0,0,1,19,5.857V16.143A2.857,2.857,0,0,1,16.143,19H5.857A2.857,2.857,0,0,1,3,16.143ZM5.857,4.143A1.714,1.714,0,0,0,4.143,5.857V16.143a1.714,1.714,0,0,0,1.714,1.714H16.143a1.714,1.714,0,0,0,1.714-1.714V7.571H10.429A1.714,1.714,0,0,1,8.714,5.857V4.143Zm12,1.714a1.714,1.714,0,0,0-1.714-1.714H9.857V5.857a.571.571,0,0,0,.571.571h7.429Z"
                transform="translate(-3 -3)"
                fill="#fff"
              />
            </svg>
            <svg
              v-else-if="
                _.vm.themeIconClasses[2].hasOwnProperty('custom custom-circle-online')
              "
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 15.867 15.867"
              style="margin-right: 8px; margin-left: 5px"
            >
              <g fill="rgba(106,235,32,0.7)">
                <path
                  d="M 7.933594226837158 15.11718463897705 C 3.972554206848145 15.11718463897705 0.7500042319297791 11.89463424682617 0.7500042319297791 7.933594226837158 C 0.7500042319297791 3.972554206848145 3.972554206848145 0.7500042319297791 7.933594226837158 0.7500042319297791 C 11.89463424682617 0.7500042319297791 15.11718463897705 3.972554206848145 15.11718463897705 7.933594226837158 C 15.11718463897705 11.89463424682617 11.89463424682617 15.11718463897705 7.933594226837158 15.11718463897705 Z"
                  stroke="none"
                />
                <path
                  d="M 7.933594226837158 1.500003814697266 C 4.386104583740234 1.500003814697266 1.500003814697266 4.386104583740234 1.500003814697266 7.933594226837158 C 1.500003814697266 11.4810848236084 4.386104583740234 14.36718463897705 7.933594226837158 14.36718463897705 C 11.4810848236084 14.36718463897705 14.36718463897705 11.4810848236084 14.36718463897705 7.933594226837158 C 14.36718463897705 4.386104583740234 11.4810848236084 1.500003814697266 7.933594226837158 1.500003814697266 M 7.933594226837158 3.814697265625e-06 C 12.31519412994385 3.814697265625e-06 15.86718463897705 3.551994323730469 15.86718463897705 7.933594226837158 C 15.86718463897705 12.31519412994385 12.31519412994385 15.86718463897705 7.933594226837158 15.86718463897705 C 3.551994323730469 15.86718463897705 3.814697265625e-06 12.31519412994385 3.814697265625e-06 7.933594226837158 C 3.814697265625e-06 3.551994323730469 3.551994323730469 3.814697265625e-06 7.933594226837158 3.814697265625e-06 Z"
                  stroke="none"
                  fill="#fff"
                />
              </g>
            </svg>
            <svg
              v-else-if="
                _.vm.themeIconClasses[2].hasOwnProperty(
                  'custom custom-circle-offline-orange'
                )
              "
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 15.867 15.867"
              style="margin-right: 8px; margin-left: 5px"
            >
              <g fill="rgba(255, 160, 60, .8)">
                <path
                  d="M 7.933594226837158 15.11718463897705 C 3.972554206848145 15.11718463897705 0.7500042319297791 11.89463424682617 0.7500042319297791 7.933594226837158 C 0.7500042319297791 3.972554206848145 3.972554206848145 0.7500042319297791 7.933594226837158 0.7500042319297791 C 11.89463424682617 0.7500042319297791 15.11718463897705 3.972554206848145 15.11718463897705 7.933594226837158 C 15.11718463897705 11.89463424682617 11.89463424682617 15.11718463897705 7.933594226837158 15.11718463897705 Z"
                  stroke="none"
                />
                <path
                  d="M 7.933594226837158 1.500003814697266 C 4.386104583740234 1.500003814697266 1.500003814697266 4.386104583740234 1.500003814697266 7.933594226837158 C 1.500003814697266 11.4810848236084 4.386104583740234 14.36718463897705 7.933594226837158 14.36718463897705 C 11.4810848236084 14.36718463897705 14.36718463897705 11.4810848236084 14.36718463897705 7.933594226837158 C 14.36718463897705 4.386104583740234 11.4810848236084 1.500003814697266 7.933594226837158 1.500003814697266 M 7.933594226837158 3.814697265625e-06 C 12.31519412994385 3.814697265625e-06 15.86718463897705 3.551994323730469 15.86718463897705 7.933594226837158 C 15.86718463897705 12.31519412994385 12.31519412994385 15.86718463897705 7.933594226837158 15.86718463897705 C 3.551994323730469 15.86718463897705 3.814697265625e-06 12.31519412994385 3.814697265625e-06 7.933594226837158 C 3.814697265625e-06 3.551994323730469 3.551994323730469 3.814697265625e-06 7.933594226837158 3.814697265625e-06 Z"
                  stroke="none"
                  fill="#fff"
                />
              </g>
            </svg>
            <svg
              v-else-if="
                _.vm.themeIconClasses[2].hasOwnProperty('custom custom-circle-offline')
              "
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 15.867 15.867"
              style="margin-right: 8px; margin-left: 5px"
            >
              <g fill="rgba(245, 50, 20, .6)">
                <path
                  d="M 7.933594226837158 15.11718463897705 C 3.972554206848145 15.11718463897705 0.7500042319297791 11.89463424682617 0.7500042319297791 7.933594226837158 C 0.7500042319297791 3.972554206848145 3.972554206848145 0.7500042319297791 7.933594226837158 0.7500042319297791 C 11.89463424682617 0.7500042319297791 15.11718463897705 3.972554206848145 15.11718463897705 7.933594226837158 C 15.11718463897705 11.89463424682617 11.89463424682617 15.11718463897705 7.933594226837158 15.11718463897705 Z"
                  stroke="none"
                />
                <path
                  d="M 7.933594226837158 1.500003814697266 C 4.386104583740234 1.500003814697266 1.500003814697266 4.386104583740234 1.500003814697266 7.933594226837158 C 1.500003814697266 11.4810848236084 4.386104583740234 14.36718463897705 7.933594226837158 14.36718463897705 C 11.4810848236084 14.36718463897705 14.36718463897705 11.4810848236084 14.36718463897705 7.933594226837158 C 14.36718463897705 4.386104583740234 11.4810848236084 1.500003814697266 7.933594226837158 1.500003814697266 M 7.933594226837158 3.814697265625e-06 C 12.31519412994385 3.814697265625e-06 15.86718463897705 3.551994323730469 15.86718463897705 7.933594226837158 C 15.86718463897705 12.31519412994385 12.31519412994385 15.86718463897705 7.933594226837158 15.86718463897705 C 3.551994323730469 15.86718463897705 3.814697265625e-06 12.31519412994385 3.814697265625e-06 7.933594226837158 C 3.814697265625e-06 3.551994323730469 3.551994323730469 3.814697265625e-06 7.933594226837158 3.814697265625e-06 Z"
                  stroke="none"
                  fill="#fff"
                />
              </g>
            </svg>
            <template v-else>
              <i
                :class="_.vm.themeIconClasses"
                role="presentation"
                v-if="!model.loading"
              ></i>
            </template>

            <template
              v-if="
                (role === 'destination' || role === 'unit_group') &&
                ['cctv', 'voip'].includes(_.model.tag)
              "
            >
              <span v-html="_.model[textFieldName].replace(/ *\([^)]*\) */g, '')"></span>
              ({{ _.model.children.length }})
            </template>
            <span
              v-else-if="_.model.in_project"
              class="tree-maintenance"
            >
              <feather-icon
                icon="ToolIcon"
                size="12"
                class="tree-maintenance__icon"
              />
              <span v-html="_.model[textFieldName]"></span>
            </span>
            <span v-else v-html="_.model[textFieldName]"></span>
          </slot>
        </template>
      </tree-item>
      <div
        v-if="showFacilitiesPager"
        class="tree-facilities-pager d-flex justify-content-end"
        role="presentation"
      >
        <div class="pagination-count d-flex align-items-center mr-25">
          {{ $t("grid.widgets.units.pagination.page") }} {{ model.currentPageFacilities }}
          {{ $t("grid.widgets.units.pagination.of") }} {{ model.lastPageFacilities }}
        </div>
        <div class="pagination">
          <button
            type="button"
            class="btn btn-sm btn-secondary rounded-0 p-0 d-flex align-items-center justify-content-center customBtnPagination"
            :disabled="model.currentPageFacilities <= 1"
            @click.stop="handleFacilitiesPage('prev')"
          >
            <i class="feather icon-chevron-left"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-secondary rounded-0 p-0 d-flex align-items-center justify-content-center customBtnPagination"
            :disabled="model.currentPageFacilities >= model.lastPageFacilities"
            @click.stop="handleFacilitiesPage('next')"
          >
            <i class="feather icon-chevron-right"></i>
          </button>
        </div>
      </div>
    </ul>
  </li>
</template>
<script>
export default {
  name: "TreeItem",
  props: {
    data: { type: Object, required: true },
    textFieldName: { type: String },
    valueFieldName: { type: String },
    childrenFieldName: { type: String },
    itemEvents: { type: Object },
    wholeRow: { type: Boolean, default: false },
    showCheckbox: { type: Boolean, default: false },
    allowTransition: { type: Boolean, default: true },
    height: { type: Number, default: 24 },
    parentItem: { type: Array },
    draggable: { type: Boolean, default: false },
    onItemClick: {
      type: Function,
      default: () => false,
    },
    onItemToggle: {
      type: Function,
      default: () => false,
    },
    onItemDragStart: {
      type: Function,
      default: () => false,
    },
    onItemDragEnd: {
      type: Function,
      default: () => false,
    },
    onItemDrop: {
      type: Function,
      default: () => false,
    },
    onItemMouseOver: {
      type: Function,
      default: () => false,
    },
    onItemOpenInNewTab: {
      type: Function,
      default: null,
    },
    onItemPaginate: {
      type: Function,
      default: () => false,
    },
    klass: String,
    mode: { type: String, default: "widget" },
    role: { type: String, default: "disabled" },
  },
  data() {
    return {
      isHover: false,
      model: this.data,
      maxHeight: 0,
      events: {},
      isDragEnter: false,
    };
  },
  watch: {
    data(newValue) {
      this.model = newValue;
    },
    "model.opened": {
      handler: function (val, oldVal) {
        this.onItemToggle(this, this.model);
        this.handleGroupMaxHeight();
      },
      deep: true,
    },
  },
  computed: {
    isFolder() {
      return (
        (this.model[this.childrenFieldName] &&
          this.model[this.childrenFieldName].length) ||
        this.model.facilitiesUrl
      );
    },
    showFacilitiesPager() {
      const children = this.model[this.childrenFieldName];
      return Boolean(
        this.model.facilitiesUrl &&
          this.model.opened &&
          Array.isArray(children) &&
          children.length &&
          this.model.lastPageFacilities > 1
      );
    },
    classes() {
      return [
        { "tree-node": true },
        { "tree-open": this.model.opened },
        { "tree-closed": !this.model.opened },
        { "tree-leaf": this.model["tag"] === "tenant" ? false : !this.isFolder },
        { "tree-loading": !!this.model.loading },
        { [this.klass]: !!this.klass },
      ];
    },
    anchorClasses() {
      return [
        { "tree-anchor": true },
        { "tree-disabled": this.model.disabled },
        { "tree-selected": this.model.selected },
        { "tree-hovered": this.isHover },
      ];
    },
    wholeRowClasses() {
      return [
        { "tree-wholerow": true },
        { "tree-wholerow-clicked": this.model.selected },
        { "tree-wholerow-hovered": this.isHover },
      ];
    },
    themeIconClasses() {
      return [
        { "tree-icon": true },
        { "tree-themeicon": true },
        { [this.model.icon]: !!this.model.icon },
        { "tree-themeicon-custom": !!this.model.icon },
      ];
    },
    isWholeRow() {
      if (this.wholeRow) {
        if (this.$parent.model === undefined) {
          return true;
        } else if (this.$parent.model.opened === true) {
          return true;
        } else {
          return false;
        }
      }
    },
    groupStyle() {
      return {
        position: this.model.opened ? "" : "relative",
        "max-height": !!this.allowTransition ? this.maxHeight + "px" : "",
        "transition-duration": !!this.allowTransition
          ? Math.ceil(this.model[this.childrenFieldName].length / 100) * 300 + "ms"
          : "",
        "transition-property": !!this.allowTransition ? "max-height" : "",
        display: !!this.allowTransition ? "block" : this.model.opened ? "block" : "none",
      };
    },
    isVisibile() {
      if (this.model.type === "action") {
        return this.model.visible;
      }

      return true;
    },
    // titleTooltip
    title() {
      if (!this.isFolder && this.model.tag === "alarm-bridge-device") {
        if (typeof this.model.info === "object") {
          const textTooltip = `${this.$t("bypassed")}: ${
            this.model.info.bypassed
          }\n${this.$t("open")}: ${this.model.info.open}\n${this.$t("tamper")}: ${
            this.model.info.tamper
          }\n${this.$t("violated")}: ${this.model.info.violated}`;
          return textTooltip;
        } else if (typeof this.model.info === "string") {
          return `${this.$t("status")}: ${this.model.info}`;
        }
      }
    },
  },
  methods: {
    handleItemToggle(e) {
      if (this.isFolder) {
        this.model.opened = !this.model.opened;
        this.onItemToggle(this, this.model);
      }
    },
    handleFacilitiesPage(direction) {
      const current = this.model.currentPageFacilities || 1;
      const page = direction === "prev" ? current - 1 : current + 1;
      if (page < 1 || page > this.model.lastPageFacilities) return;
      this.onItemPaginate(this, this.model, page);
    },
    handleGroupMaxHeight() {
      if (!!this.allowTransition) {
        let length = 0;
        let childHeight = 0;
        if (this.model.opened) {
          length = this.$children.length;
          for (let children of this.$children) {
            childHeight += children.maxHeight;
          }
        }
        // The pager is plain markup inside the group, not a child component, so it is not in `length`.
        const pagerHeight = this.showFacilitiesPager ? this.height : 0;
        this.maxHeight = length * this.height + childHeight + pagerHeight;
        if (this.$parent.$options._componentTag === "tree-item") {
          this.$parent.handleGroupMaxHeight();
        }
      }
    },
    handleItemClick(e) {
      if (this.model.disabled) return;
      //detect if user do clic with control or command key
      if (e && (e.ctrlKey || e.metaKey) && this.onItemOpenInNewTab) {
        this.onItemOpenInNewTab(this, this.model, e);
        return;
      }
      this.model.selected = !this.model.selected;
      this.onItemClick(this, this.model, e);
    },
    handleItemMouseOver() {
      this.isHover = true;
      // Only for intelbras bridge alarm devices, if new devices are added, they must be added here
      if (!this.isFolder && this.model.tag === "alarm-bridge-device") {
        // Function that runs when you mouse over the element from a subsystemTree composable
        this.onItemMouseOver(this, this.model);
      }
    },
    handleItemMouseOut() {
      this.isHover = false;
      this.$root.$emit("bv::hide::tooltip");
    },
    handleItemDrop(e, oriNode, oriItem) {
      this.$el.style.backgroundColor = "inherit";
      this.onItemDrop(e, oriNode, oriItem);
    },
    resolveDraggableStatus(child) {
      if (this.mode === "editor") {
        return true;
      }
      return child.type === "action" || child.tag === "camera";
    },
    buildParentData(model) {
      if (model) {
        let tmp = JSON.parse(JSON.stringify(model));
        delete tmp.children;
        return JSON.stringify(tmp);
      }
    },
    getCameraDataCy() {
      const { tag, data, id, text } = this.model;

      const tagConfigs = {
        'camera-name': () => {
          const cameraName = data?.name?.replace(/\s+/g, '-').toLowerCase() || 'unnamed';
          return data?.id ? `tenant-camera-unit-${data.id}-${cameraName}` : undefined;
        },
        'live-video': () => data?.id ? `tenant-camera-live-video-${data.id}` : undefined,
        'recorded-video': () => data?.id ? `tenant-camera-recorded-video-${data.id}` : undefined,
        'info': () => data?.id ? `tenant-camera-info-${data.id}` : undefined,
        'facility': () => {
          const facilityName = text?.replace(/\s+/g, '-').toLowerCase() || 'unnamed';
          return id ? `tenant-unit-${id}-${facilityName}` : undefined;
        },
        'tenant': () => {
          const tenantName = text?.replace(/\s+/g, '-').toLowerCase() || 'unnamed';
          return id ? `tenant-${id}-${tenantName}` : undefined;
        }
      };

      return tagConfigs[tag]?.() || undefined;
    }
  },
  created() {
    const self = this;
    const events = {
      click: this.handleItemClick,
      mouseover: this.handleItemMouseOver,
      mouseout: this.handleItemMouseOut,
    };
    for (let itemEvent in this.itemEvents) {
      let itemEventCallback = this.itemEvents[itemEvent];
      if (events.hasOwnProperty(itemEvent)) {
        let eventCallback = events[itemEvent];
        events[itemEvent] = function (event) {
          eventCallback(self, self.model, event);
          itemEventCallback(self, self.model, event);
        };
      } else {
        events[itemEvent] = function (event) {
          itemEventCallback(self, self.model, event);
        };
      }
    }
    this.events = events;
  },
  mounted() {
    this.handleGroupMaxHeight();
  },
};
</script>
